<template>
  <div class="insights-page">
    <PageHeaderPortal>
      <div class="page-header-left">
        <div class="page-icon">
          <i class="fa-duotone fa-building"></i>
        </div>
        <div>
          <h1 class="page-title">swiftUW</h1>
          <p class="page-subtitle">Underwriting conditions and portfolio insights</p>
        </div>
      </div>
    </PageHeaderPortal>

    <div class="insights-body">
      <ConditionInsights
        :azureId="azureId"
        :authToken="authToken"
        :orgId="orgId"
      />
    </div>
  </div>
</template>

<script>
import auth from "@/authConfig"
import ConditionInsights from "@/components/Insights/ConditionInsights.vue"
import PageHeaderPortal from "@/views/PageHeaderPortal.vue"

export default {
  name: "Insights",
  components: {
    ConditionInsights,
    PageHeaderPortal
  },
  data() {
    return {
      token: null,
      authToken: "",
      azureId: "",
      orgId: null
    }
  },
  methods: {
    async initAuth() {
      this.token = await auth.acquireTokenResponse()
      this.authToken = this.token?.accessToken || this.token?.idToken || ""
      this.azureId = localStorage.getItem("azure_id") || ""
    }
  },
  async mounted() {
    await this.initAuth()
  }
}
</script>

<style scoped>
.page-shell {
  width: 100%;
  min-height: 100%;
  padding: 12px;
}

.insights-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.insights-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  overflow: auto;
}

.page-header-left { display: flex; align-items: center; gap: 14px; flex: 0 0 auto; }
.page-icon {
  width: 48px; height: 48px;
  border-radius: 5px;
  background: #123a71;
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 20px;
  flex: 0 0 auto;
}
.page-title  { margin: 0; font-size: 20px; font-weight: 700; color: #1f2a44; letter-spacing: -.01em; }
.page-subtitle { margin: 4px 0 0; font-size: 13px; color: #7b8397; font-weight: 500; }
</style>